import { render, staticRenderFns } from "./RTPNormList.vue?vue&type=template&id=4adc1ccb&"
import script from "./RTPNormList.vue?vue&type=script&lang=js&"
export * from "./RTPNormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adc1ccb')) {
      api.createRecord('4adc1ccb', component.options)
    } else {
      api.reload('4adc1ccb', component.options)
    }
    module.hot.accept("./RTPNormList.vue?vue&type=template&id=4adc1ccb&", function () {
      api.rerender('4adc1ccb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RTPNormList.vue"
export default component.exports